"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCreatable = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var createItemId = 0;
var newItemFactory = function newItemFactory(inputValue) {
  return {
    label: inputValue,
    value: (createItemId -= 1).toString(),
    userCreated: true
  };
};
function allowItemCreation(items, searchTerm, previouslyCreatedItems) {
  if (searchTerm === '') {
    return false;
  }
  var allItems = items.concat(previouslyCreatedItems);
  return !allItems.some(function (i) {
    return i.label === searchTerm;
  });
}
var withCreatable = exports.withCreatable = function withCreatable(items, searchTerm, previouslyCreatedItems) {
  if (allowItemCreation(items, searchTerm, previouslyCreatedItems)) {
    return [].concat((0, _toConsumableArray2["default"])(items), [newItemFactory(searchTerm)]);
  } else {
    return items;
  }
};